import { UnitSystem } from '@trackman/baseball-shared-components';

const inchesToMeters = (value: number) => {
  return (value * 2.54).toFixed(2);
};

const metersToInches = (value: string | number) => {
  return (Number(value) / 2.54).toFixed(2);
};

const getMetricValue = (value: number, metrics: UnitSystem) => {
  if (metrics === UnitSystem.Imperial) {
    return `${Number(value).toFixed(2)} in`;
  }

  return Number(value).toFixed(2) + ' cm';
};

const getValue = (value?: string | number, metrics?: UnitSystem) => {
  if (!value && value !== 0) {
    return undefined;
  }

  if (metrics === UnitSystem.Imperial) {
    return Number(value).toFixed(2);
  }

  return unitConverters.inchesToMeters(Number(value));
};

export const unitConverters = {
  inchesToMeters,
  getMetricValue,
  getValue,
  metersToInches,
};
